
import { MapUtils } from '../../utility/map-utils.js';
import { cloneListOfCloneable, DataModelBuilder, isSameData,
  isSameList, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { Component } from '../core/component.js';
import { ServiceAttendanceGroup } from './service-attendance-group.js';
import { PriceType } from '../../models/serializable/price-type.js';

export class ServiceAttendanceComponent extends Component {
  static readonly TYPE_ID: string = '6ae8dfadf66044e186d090ca570c05f3';

  constructor(
        public readonly groups: ServiceAttendanceGroup[],
        public readonly priceType: PriceType,
  ) {
    super();
  }

  get $typeId(): string {
    return ServiceAttendanceComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static empty(priceType?: PriceType): ServiceAttendanceComponent {
    return new ServiceAttendanceComponent(
        [],
        priceType ?? PriceType.PricePerService,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData) {
    return new ServiceAttendanceComponent(
        MapUtils.getList(map, 'groups', (data) => context.fromData(data as SerializedData)),
        MapUtils.get<PriceType>(map, 'priceType'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'groups': this.groups.map((e) => context.toData(e)),
      'priceType': this.priceType,
    };
  }

  clone(): this {
    return new ServiceAttendanceComponent(
        cloneListOfCloneable(this.groups),
        this.priceType,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.groups, this.groups, (a, b) => isSameData(a, b)) &&
        other.priceType === this.priceType;
  }
}

export class ServiceAttendanceComponentBuilder extends DataModelBuilder<ServiceAttendanceComponent> {
  build(context: SerializationContext, map: SerializedData): ServiceAttendanceComponent {
    return ServiceAttendanceComponent.fromMap(context, map);
  }

  migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    this.migrateEnum(map, 'priceType', PriceType, PriceType.PricePerService);

    return map;
  }
}
